export default __webpack_public_path__ + "static/media/TODO_EN_UNO_ICON.c012bda5.svg";